import { Component } from '@angular/core';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent {

  formType !: string;

  constructor(private formService: FormService) {}
  
  ngOnInit(): void {
    this.formType = this.formService.getCurrentUsanFormValue()?.get('formType')?.value;
  }

}
